export enum ZoneTypeEnum {
  ZONE = "zone",
  COMPONENT = "component"
}
